import { supabase } from '../../lib/supabase'

// Helper function to fetch user settings from Supabase
export async function fetchUserSettings(userId: string) {
  const { data, error: fetchError } = await supabase
    .from('user_settings')
    .select('follow_up_days_after_applied, deadline_days_after_saved')
    .eq('user_id', userId)
    .maybeSingle()

  if (fetchError) {
    console.warn('Failed to load user settings (using defaults):', fetchError)
    return null
  }

  return data
}

// Helper function to apply user settings
export function applyUserSettings(
  data: { follow_up_days_after_applied?: number | null; deadline_days_after_saved?: number | null } | null,
  setUserRules: React.Dispatch<React.SetStateAction<{ follow_up_days_after_applied?: number | null; deadline_days_after_saved?: number | null }>>
) {
  if (data) {
    setUserRules({
      follow_up_days_after_applied: data.follow_up_days_after_applied ?? 7,
      deadline_days_after_saved: data.deadline_days_after_saved ?? 14,
    })
  }
}

// Helper function to get current user
export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser()
  return user
}

// Helper function to handle user settings loading error
export function handleUserSettingsError(err: unknown) {
  console.error('Error loading user settings:', err)
}

// Helper function to process user settings
export async function processUserSettings(
  userId: string,
  setUserRules: React.Dispatch<React.SetStateAction<{ follow_up_days_after_applied?: number | null; deadline_days_after_saved?: number | null }>>
) {
  const settingsData = await fetchUserSettings(userId)
  applyUserSettings(settingsData, setUserRules)
}

// Helper function to check if user exists
export function checkUserExists(user: { id: string } | null): boolean {
  return !!user
}

// Helper function to load user settings with user check
export async function loadUserSettingsWithUser(
  setUserRules: React.Dispatch<React.SetStateAction<{ follow_up_days_after_applied?: number | null; deadline_days_after_saved?: number | null }>>
) {
  const user = await getCurrentUser()
  if (!checkUserExists(user)) return
  await processUserSettings(user!.id, setUserRules)
}

export async function loadUserSettings(
  setUserRules: React.Dispatch<React.SetStateAction<{ follow_up_days_after_applied?: number | null; deadline_days_after_saved?: number | null }>>
) {
  try {
    await loadUserSettingsWithUser(setUserRules)
  } catch (err) {
    handleUserSettingsError(err)
  }
}
